// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"1dece222","453":"bc91ce2c"}[chunkId] + ".chunk.js";
};